<template>
    <div class="layout-header">
        <ul>
            <li class="header-li user-avatar"><img :src="logoUrl"></li>
            <li class="header-li user-line"></li>
            <li class="header-li user-header-logo">{{ state.softwareTitle || 'AR交互协作平台' }}</li>
            <li class="header-li user-header-tab">
<!--                <a href="javascript:" class="li" :class="headerMenuId === menuList[0].code || !headerMenuId ?'active':''" @click="onHeaderMenu(menuList[0].code)">{{ menuList[0].value }}</a>-->
                <div class="li-box" :class="headerMenuId === menu.code || (menu.code === 2 && headerMenuId === 4) || !headerMenuId?'active':''" :key="key" v-for="(menu,key) in menuList">
                    <a href="javascript:void(0)" class="li" v-if="menu.code === 1"  @click="onHeaderMenu(1,0)">
                        {{ menu.value }}
                    </a>
                    <Dropdown trigger="click" placement="bottom-start" v-if="menu.code !==1">
                        <a href="javascript:void(0)" class="li">
                            {{ menu.value }}
                            <Icon type="ios-arrow-down" v-if="menu.menuCode!=='conversation-websocket'"></Icon>
                        </a>
                        <template #list>
                            <DropdownMenu>
                                <DropdownItem style="padding-left: 38px;" :style="menuId === 1?'color:#2D8CF0;font-weight: bold;':''"  @click.native="onHeaderMenu(2,1)" v-if="menu.menuCode === 'knowledge-base-service'">设备知识库</DropdownItem>
                                <DropdownItem style="padding-left: 38px;" :style="menuId === 2?'color:#2D8CF0;font-weight: bold;':''"   @click.native="onHeaderMenu(2,2)" v-if="menu.menuCode === 'knowledge-base-service'">档案管理库</DropdownItem>
                                <DropdownItem style="padding-left: 30px;" :style="menuId === 3?'color:#2D8CF0;font-weight: bold;':''" @click.native="onHeaderMenu(3,3)" v-if="menu.menuCode === 'site-inspection'">作业任务</DropdownItem>
                                <DropdownItem style="padding-left: 30px;" :style="menuId === 4?'color:#2D8CF0;font-weight: bold;':''" @click.native="onHeaderMenu(3,4)" v-if="menu.menuCode === 'site-inspection'">作业记录</DropdownItem>
                            </DropdownMenu>
                        </template>
                    </Dropdown>
                </div>
            </li>
            <li class="header-li user-box">
                <div class="link" v-if="state.isAdmin && (linkUrl === 'production' || linkUrl === 'test' || linkUrl === 'development')">
                    <a :href="linkUrl === 'production'?'https://admin.lingyun.ustep.cn/':'https://test.admin.lingyun.ustep.cn/'">进入后台管理  <Icon type="md-arrow-forward" /></a>
                </div>
                <div class="link" v-if="state.isAdmin && linkUrl === 'privatization'">
                    <a href="https://10.21.102.105:8083/login">进入后台管理  <Icon type="md-arrow-forward" /></a>
                </div>
                <Dropdown trigger="click" placement="bottom-end">
                    <div class="user-info" @click="onModalCode">
                        <Avatar :src="state.profilePictureUrl || defaultAvatar" class="avatar" icon="ios-person"/>
                        <font>{{ state.name }}</font>
                    </div>
                    <div class="user-item" slot="list">
                        <div class="item-top">
                            <Avatar shape="square" :src="state.profilePictureUrl || defaultAvatar" class="avatar" icon="ios-person"/>
                            <dl>
                                <dt>{{ state.name }}</dt>
<!--                                <dd>部门&#12288;职务</dd>-->
                            </dl>
                        </div>
                        <div class="item-code">
                            <h2 class="title">眼镜端登录二维码</h2>
                            <h3 class="text">使用眼镜扫码&#12288;登录远程协作</h3>
                            <div class="code">
                                <vue-qr :logoSrc="logoSrc" :text="QRCode" class="layout-code"></vue-qr>
                            </div>
                            <Button type="error" long @click="onSignOut">退出登录</Button>
                        </div>
                    </div>
                </Dropdown>
            </li>
        </ul>
    </div>
</template>

<script>
import Header from './index'
export default Header
</script>

